// src/pages/ParcaKatalog.js
import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const ParcaKatalog = () => {
  const [parcalar, setParcalar] = useState([]);
  const [yeniParca, setYeniParca] = useState({
    ad: '',
    kategori: '',
    kod: '',
    aciklama: '',
    paraBirimi: '₺',
    fiyat: '',
  });

  useEffect(() => {
    const veri = JSON.parse(localStorage.getItem('parcaKatalogu')) || [];
    setParcalar(veri);
  }, []);

  const handleDegisiklik = (e) => {
    const { name, value } = e.target;
    setYeniParca((prev) => ({ ...prev, [name]: value }));
  };

  const handleEkle = () => {
    const guncel = [...parcalar, yeniParca];
    setParcalar(guncel);
    localStorage.setItem('parcaKatalogu', JSON.stringify(guncel));
    setYeniParca({ ad: '', kategori: '', kod: '', aciklama: '', paraBirimi: '₺', fiyat: '' });
  };

  return (
    <div className="max-w-5xl mx-auto">
      <Card>
        <CardContent className="space-y-6">
          <h2 className="text-2xl font-bold">Parça Kataloğu</h2>
          <div className="grid grid-cols-3 gap-4">
            <Input name="ad" placeholder="Parça Adı" value={yeniParca.ad} onChange={handleDegisiklik} />
            <Input name="kategori" placeholder="Kategori" value={yeniParca.kategori} onChange={handleDegisiklik} />
            <Input name="kod" placeholder="Parça Kodu" value={yeniParca.kod} onChange={handleDegisiklik} />
            <Input name="aciklama" placeholder="Açıklama" value={yeniParca.aciklama} onChange={handleDegisiklik} />
            <select
              name="paraBirimi"
              value={yeniParca.paraBirimi}
              onChange={handleDegisiklik}
              className="border p-2 rounded"
            >
              <option value="₺">₺ (TL)</option>
              <option value="$">$ (USD)</option>
              <option value="€">€ (EUR)</option>
            </select>
            <Input name="fiyat" placeholder="Fiyat" value={yeniParca.fiyat} onChange={handleDegisiklik} />
          </div>
          <Button onClick={handleEkle}>Parçayı Ekle</Button>
        </CardContent>
      </Card>

      <div className="mt-8">
        <h3 className="text-lg font-semibold mb-4">Kayıtlı Parçalar</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {parcalar.map((item, i) => (
            <div key={i} className="border rounded p-4 bg-white shadow">
              <p><strong>Ad:</strong> {item.ad}</p>
              <p><strong>Kategori:</strong> {item.kategori}</p>
              <p><strong>Kod:</strong> {item.kod}</p>
              <p><strong>Açıklama:</strong> {item.aciklama}</p>
              <p><strong>Fiyat:</strong> {item.fiyat} {item.paraBirimi}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ParcaKatalog;
